import React from "react";
import CardSummary from "../../common/CardSummary";

const SkeletonBox = ({ width, height }) => (
  <div
    className="skeleton-box"
    style={{ width: width || '80px', height: height || '20px' }}
  />
);

const OverviewCard = ({
  title,
  value,
  percentageChange,
  formattedPercentageChange,
  showPercentageChange = true,
  link = "",
  showLink = false,
  isLoading = false,
  showBg = false,
  helperText = "",
  helperTone = "muted"
}) => {
  return (
    <CardSummary
      title={title}
      rate={formattedPercentageChange??""}
      color={percentageChange > 0 ? "success" : "danger"}
      showLink={showLink && !isLoading}
      showRate={false}
      to={link}
      showBg={showBg}
    >
      {isLoading ? (
        <div className="d-flex flex-column" style={{ gap: '6px', paddingTop: '4px' }}>
          <SkeletonBox width="90px" height="26px" />
          <SkeletonBox width="54px" height="16px" />
        </div>
      ) : (
        <>
          <span className="num bold fs-7">
            <b>{value}</b>
          </span>
          {showPercentageChange && (
            <span className={`muted fs-1 mb-2 pl-2 ${percentageChange > 0 ? "text-success" : "text-danger"}`}>
              {formattedPercentageChange}
            </span>
          )}
          {helperText && (
            <div className={`fs--1 mt-1 ${helperTone === "success" ? "text-success" : helperTone === "danger" ? "text-danger" : "text-muted"}`}>
              {helperText}
            </div>
          )}
        </>
      )}
    </CardSummary>
  );
};

export default OverviewCard;
